import React, { Fragment, useState } from 'react'
import cn from 'classnames';
import { Tab } from '@headlessui/react'
import { useSelector } from 'react-redux';
import { selectCurrent } from '../../../../redux/settings/selectors';
import _ from 'lodash';

export default function TabContainer({ tabItems, selectedIndex, onChange = (i: any) => {} }: any) {
  const [color, setColor] = useState('universal')
  const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar,theme,primary ,secondary} = result
  const filteredTabData: any = _.filter(tabItems, ['isVisible', true])
  return (
 
    <div className="w-full px-4 py-4 sm:px-0 bg-white">
      <Tab.Group  onChange={(index) => {onChange(index)}} selectedIndex={selectedIndex}>
        <Tab.List className="mt-3 mx-2 flex flex-wrap border-b border-white-light dark:border-[#191e3a]">
          {filteredTabData.map((tab: any) => (
            <Tab as={Fragment} key={tab.id}>
              {({ selected }) => (
                <button
                  className={`${tab.isVisible ? 'visible' : 'hidden'}
                    ${
                      selected
                        ? '!border-skin-primary !border-b-white text-skin-primary dark:!border-[#191e3a] dark:!border-b-black'
                        : ''
                    } p-3.5 py-2 -mb-[1px] flex items-center border border-transparent hover:text-danger !outline-none transition duration-300`}
                >
                  {/* <svg>...</svg> */}
                  {tab.title}
                </button>
              )}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="mt-2 mx-2">
          {filteredTabData.map((tab:any, idx:any) => (
            <Tab.Panel key={idx}>
              <div className="active pt-5">{tab.component}</div>
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  )
}
